'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UILink from 'UIComponents/link/UILink';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class FormLabelWithHelpLink extends Component {
  render() {
    const {
      primaryText,
      linkText,
      onLinkClick,
      required
    } = this.props;
    return /*#__PURE__*/_jsxs(UIFlex, {
      direction: "row",
      align: "baseline",
      justify: "between",
      children: [/*#__PURE__*/_jsx(UIFormLabel, {
        required: required,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: primaryText
        })
      }), linkText ? /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(UILink, {
          onClick: onLinkClick,
          "data-test-id": this.props['data-test-id'],
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: linkText
          })
        })
      }) : null]
    });
  }
}
FormLabelWithHelpLink.propTypes = {
  primaryText: PropTypes.string.isRequired,
  linkText: PropTypes.string,
  onLinkClick: PropTypes.func,
  required: PropTypes.bool,
  ['data-test-id']: PropTypes.string
};
FormLabelWithHelpLink.defaultProps = {
  onLinkClick: () => {}
};